<template>
  <div>
    <template v-if="user && user.uuid">
      <DropdownMenu>
        <DropdownMenuTrigger as-child>
          <div v-if="!isCollapsed" class="user-card">
            <img :src="avatar" alt="" class="w-8 h-8 rounded-lg shrink-0" />
            <div
              class="flex flex-col justify-center overflow-hidden flex-1 min-w-0"
            >
              <div class="name">
                {{ user.first_name }} {{ user.last_name || "" }}
              </div>
              <div v-if="subtitle" class="identifier truncate">
                {{ subtitle }}
              </div>
            </div>
            <div class="product-switch-icon">
              <svg
                class="switch-icon"
                aria-hidden="true"
                viewBox="-1.6 -1.6 19.2 19.2"
                fill="rgb(var(--color-gray-600))"
              >
                <path
                  fill-rule="evenodd"
                  d="M3.646 9.146a.5.5 0 01.708 0L8 12.793l3.646-3.647a.5.5 0 01.708.708l-4 4a.5.5 0 01-.708 0l-4-4a.5.5 0 010-.708zm0-2.292a.5.5 0 00.708 0L8 3.207l3.646 3.647a.5.5 0 00.708-.708l-4-4a.5.5 0 00-.708 0l-4 4a.5.5 0 000 .708z"
                ></path>
              </svg>
            </div>
          </div>
          <div v-else class="avatar-collapsed">
            <img :src="avatar" alt="" class="image-sm" />
          </div>
        </DropdownMenuTrigger>

        <DropdownMenuContent
          :side="isCollapsed ? 'top' : 'right'"
          align="end"
          :side-offset="8"
          class="w-[260px] p-1 cursor-pointer"
        >
          <DropdownMenuLabel class="p-0">
            <div class="flex items-center gap-2.5 px-2 py-2">
              <img :src="avatar" alt="" class="w-9 h-9 rounded-lg shrink-0" />
              <div class="flex flex-col min-w-0">
                <div class="name">
                  {{ user.first_name }} {{ user.last_name || "" }}
                </div>
                <div v-if="subtitle" class="identifier truncate">
                  {{ subtitle }}
                </div>
              </div>
            </div>
          </DropdownMenuLabel>

          <DropdownMenuSeparator />

          <DropdownMenuGroup>
            <DropdownMenuItem @select="openProfile">
              <svg-icon name="huge-user" class="w-4 h-4" style="fill: none" />
              <div>Профиль</div>
            </DropdownMenuItem>

            <DropdownMenuItem disabled>
              <svg-icon name="sli-bell" class="w-4 h-4" style="fill: none" />
              <div>Уведомления</div>
            </DropdownMenuItem>
          </DropdownMenuGroup>

          <DropdownMenuSeparator />

          <DropdownMenuItem @select="logout">
            <svg-icon name="sli-logout" class="w-4 h-4" style="fill: none" />
            <div>Выйти</div>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </template>

    <template v-else>
      <div v-if="!isCollapsed" class="user-card">
        <img :src="avatar" alt="" class="w-8 h-8 rounded-lg" />
      </div>
      <div v-else class="avatar-collapsed">
        <img :src="avatar" alt="" class="image-sm" />
      </div>
    </template>
  </div>
</template>

<script>
import AuthService from "@/shared/auth/AuthService";
import { authPort } from "@/shared/auth/authPort";
import { USER_PROFILE_DRAWER_KEY } from "@/widgets/user-profile-drawer";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/shared/ui/dropdown-menu";

export default {
  name: "UserProfile",
  components: {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuGroup,
    DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
  },
  inject: {
    userProfileDrawer: { from: USER_PROFILE_DRAWER_KEY, default: null },
  },
  props: {
    isCollapsed: {
      type: Boolean,
      default: false,
    },
    avatar: {
      type: String,
      required: true,
    },
    user: {
      type: Object,
      required: true,
    },
  },
  computed: {
    subtitle() {
      return this.user.email || this.user.identifier || "";
    },
  },
  methods: {
    openProfile() {
      this.userProfileDrawer?.open();
    },
    async logout() {
      try {
        await this.$confirm(
          this.$t("Вы действительно хотите выйти?").toString(),
          this.$t("Внимание").toString(),
          {
            confirmButtonText: this.$t("Да"),
            cancelButtonText: this.$t("Отмена"),
          }
        );

        const authService = new AuthService(authPort, null, null);
        await authService.logout("nclayer");

        this.$message.success(this.$t("Вы вышли из системы"));

        setTimeout(() => {
          window.location.reload();
        }, 300);
      } catch (error) {
        console.error("Ошибка при выходе:", error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.user-card {
  @apply flex items-center gap-2 rounded-md p-2 transition-colors cursor-pointer w-full;
  background-color: transparent;

  &:hover {
    background-color: hsl(var(--sidebar-accent));
  }

  &[data-state="open"] {
    background-color: hsl(var(--sidebar-accent));
  }
}

.name {
  @apply text-xs font-medium whitespace-normal break-words;
  color: hsl(var(--sidebar-foreground));
}

.identifier {
  @apply text-xs;
  color: hsl(var(--sidebar-foreground) / 0.6);
}

.image-sm {
  @apply w-8 h-8 rounded-lg shrink-0;
}

.avatar-collapsed {
  @apply flex items-center justify-center w-full py-1 cursor-pointer;
}

.product-switch-icon {
  @apply flex justify-center items-center text-gray-500;
}

.switch-icon {
  width: 20px;
  height: 20px;
}
</style>
